module.exports = __webpack_public_path__ + "img/spring_trip-20160416-23.9c48d9e2.jpg";